import * as React from 'react';
import {Link, NavLink, useHistory, Redirect} from 'react-router-dom';

import queryString from 'query-string';
import {Tabs} from 'antd';

import {List} from '@common/typescript/objects/List';

import {rest} from '@app/components/Api';
import { Area } from '@app/objects/Area';
import SearchField from '@app/components/Forms/SearchField/SearchField';
import listenerForBrowser from '@app/components/Pages/listenerForBrowser';

import '@app/scss/components/areasList.scss';
import {Veterinarian} from '@app/objects/Veterinarian';
import GetInTouchButton from '@app/components/Forms/GetInTouch/GetInTouchButton';
import VetNotFound from '@app/components/Pages/AreasList/VetNotFound';
import AreaNotFound from '@app/components/Pages/AreasList/AreaNotFound';
import MiddleText from '@app/components/UI/MiddleText/MiddleText';
import {getImagePath} from '@app/objects/Image';

const searchIcon = require('@app/images/search_white.svg');
const { TabPane } = Tabs;

const AreasList = (props) => {
	const valueQuery = queryString.parse(props.location.search);
	const [areas, setAreas] = React.useState<Area[]>([]);
	const [hasListAreas, setHasListArea] = React.useState<boolean>(false);
	const [hasListVets, setHasListVets] = React.useState<boolean>(false);
	const [veterinarians, setVeterinarians] = React.useState<Veterinarian[]>([]);
	const [innerQuery, setInnerQuery] = React.useState(valueQuery.query || '');
	const [activeKey, setActiveKey] = React.useState('');
	const {type} = props.location.state || 'veterinarian';
	const [queryType, setQueryType] = React.useState(type);
	const [isMobile, setIsMobile] = React.useState(false);
	const [inputValue, setInputValue] = React.useState('');
	const vetsInAreasCount = areas.length && areas.map(item => item.vetsCount).reduce((a, b) => a + b);

	const avatarHeight = 144;
	const avatarWidth = 144;

	const history = useHistory();

	const checkCountAndRedirect = function (count: number, url?: string, areaUrl?: string) {
		if (areaUrl && count === 1) {
			history.push(url);
		}
	};

	React.useEffect(() => {
		queryType === 'veterinarian' ?
			rest.get<List<Veterinarian>>(`v1/veterinarians?name=${innerQuery}`)
				.then((res) => {
					setVeterinarians(res.list);
					setHasListVets(true);
					setHasListArea(false);
					setInputValue('');
					setActiveKey('2');

					checkCountAndRedirect(
						res.list.length,
						`/find-a-vet/${res.list[0]?.area.state.split( ' ').join('-')}/${res.list[0]?.areaUrl}/veterinarians?veterinarian=${res.list[0]?.id}`,
						res.list[0]?.areaUrl);
				})

			: rest.get<List<Area>>(`v1/areas/${innerQuery}`)
				.then((res) => {
					setAreas(res.list);
					setHasListArea(true);
					setHasListVets(false);
					setInputValue('');
					setActiveKey('1');

					checkCountAndRedirect(res.list.length, `/find-a-vet/${res.list[0]?.state?.replace(' ', '-')}/${res.list[0]?.url}/about`);
				});

	}, [innerQuery]);

	React.useEffect(() => {
		const mql = window.matchMedia('screen and (max-width: 600px)');

		const listenerFunc = () => {
			if (mql.matches) {
				setIsMobile(true);
			} else {
				setIsMobile(false);
			}
		};
		listenerFunc();
		listenerForBrowser(mql, listenerFunc);
	}, []);

	return  (
		<div className="areas-list-page">
			<div className="areas-list-page__inner">
				<div className="search-field-toggle">
					<Tabs
						type="card"
						activeKey={activeKey}
						onTabClick={(key) => {
							key === '1' ? setQueryType('state') : setQueryType('veterinarian');
							setActiveKey(key);
						}}
						tabBarExtraContent={
							<SearchField
								// value={inputValue || ''}
								setValue={setInputValue}
								widthBorder={'0'}
								setSearch={setInnerQuery}
								tab={activeKey}
								autoFocus={true}
								placeholder="Enter your 5-digit ZIP code"
							/>}>
						<TabPane tab="Location" key="1">
							{hasListAreas ? (
								<div>
									{areas.length > 0 ? (
										areas.length > 1 ? (
											<React.Fragment>
												<div className="areas-list-page__results">
													<div className="areas-list__titles-row">
														<span className="areas-list__title">Veterinarians in:{' '}
															<span className="text-capitalize">{valueQuery.query}</span>
														</span>
														<span className="areas-list__title">{vetsInAreasCount} Veterinarians found</span>
													</div>
													<div className="areas-list">
														{areas.map((area, i) => (
															<React.Fragment key={`${i}-${area.name}`}>
																{isMobile ?
																	<Link
																		to={`/find-a-vet/${area.state.split( ' ').join('-')}/${area.url}/about`}
																		className="areas-list__item area-preview"
																		key={`${i}-${area.name}`}
																	>
																		<div className="area-preview__img-wrap">
																			<img src={getImagePath(area.avatar, avatarHeight, avatarWidth)} alt={area.name}/>
																		</div>
																		<div className="area-preview__info">
																			<p className="area-preview__location"><span>{area.state}:</span> {area.name}</p>
																			<p className="area-preview__contact">
																				<span className="area-preview__vets-count">{`${area.vetsCount} Veterinarian${area.vetsCount > 1 ? 's' : ''}` }</span>
																				<span className="area-preview__phone">Phone:
																					<a href={`tel:${area.phoneNumber}`}>{area.phoneNumber}</a>
																				</span>
																			</p>
																		</div>
																	</Link>
																	:
																	<div className="areas-list__item area-preview" key={`${i}-${area.name}`}>
																		<div className="area-preview__img-wrap"><img src={getImagePath(area.avatar, avatarHeight, avatarWidth)} alt={area.name}/>
																		</div>
																		<div className="area-preview__info">
																			<p className="area-preview__location"><span>{area.state}:</span> {area.name}</p>
																			<p className="area-preview__contact">
																				<span className="area-preview__vets-count">{`${area.vetsCount} Veterinarian${area.vetsCount > 1 ? 's' : ''}` }</span>
																				<span className="area-preview__phone">Phone:
																			<a href={`tel:${area.phoneNumber}`}>{area.phoneNumber}</a>
																		</span>
																			</p>
																		</div>
																		<Link
																			to={`/find-a-vet/${area.state.split( ' ').join('-')}/${area.url}/about`}
																			className="btn btn-sm btn-primary area-preview__btn"
																		>
																			View
																		</Link>
																	</div>
																}
															</React.Fragment>
														))}
													</div>
												</div>

												<div className="call-us">
													<p className="call-us__text">Can't find what you're looking for?</p>
													{
														isMobile ? <a className="btn btn-md btn-primary" href="tel:855-933-5683">Give us a call</a> :
															<GetInTouchButton btnText={'Give us a call'} />
													}
												</div>
											</React.Fragment>
										) : (
											<Redirect to={`/find-a-vet/${areas[0].state.split(' ').join('-')}/${areas[0].url}/about`} />
										)
									) : (
										<AreaNotFound isMobile={isMobile}/>
									)
									}
								</div>
							) : (
								<div className="areas-list-page__not-found">
									<MiddleText
									title={'Want to search by your location instead?'}
									text={'Please enter your 5-digit ZIP code to find a Lap of Love veterinarian near you.'}
									/>
								</div>
							)
							}
						</TabPane>
						{/* <TabPane tab="Veterinarian" key="2">
							{
								hasListVets ?
									(<>
										{veterinarians.length > 0 ?
												<div className="vet-search-res">
													{valueQuery.query && <div className="vet-search-res__head">
														<span>{`Veterinarians named: ${valueQuery.query}`}</span>
														<span>{`${veterinarians.length} Veterinarians found`}</span>
													</div>}
													<div className="vet-search-container">
														{
															veterinarians.map((vet, i) => {
																return (
																	<React.Fragment key={`${i}-${vet.id}`}>
																		{isMobile ?

																			vet.areaUrl ?
																			<NavLink
																				to={`/find-a-vet/${vet.area.state.split( ' ').join('-')}/${vet.areaUrl}/veterinarians?veterinarian=${vet.id}`}
																				key={vet.id}
																				className="vet-search__card"
																			>
																				<div className="vet-search__card-avatar">
																					<img src={getImagePath(vet.avatar, avatarHeight, avatarWidth)} alt="veterinarian"/>
																				</div>
																				<div className="vet-search__card-descr">
																					<h3>{`Dr. ${vet.firstName} ${vet.lastName}`}</h3>
																					<span>{vet.areaName}</span>
																					<span className="vet-search__card-phone">Phone:
																						<a href={`tel:${vet.phoneNumber}`}>{vet.phoneNumber}</a>
																					</span>
																				</div>
																			</NavLink>
																				: (<div
																					key={vet.id}
																					className="vet-search__card"
																					>
																						<div className="vet-search__card-avatar">
																							<img src={getImagePath(vet.avatar, avatarHeight, avatarWidth)} alt="veterinarian"/>
																						</div>
																						<div className="vet-search__card-descr">
																							<h3>{`Dr. ${vet.firstName} ${vet.lastName}`}</h3>
																							<span>{vet.areaName}</span>
																							<span className="vet-search__card-phone">Phone:
																								<a href={`tel:${vet.phoneNumber}`}>{vet.phoneNumber}</a>
																							</span>
																						</div>
																					</div>)
																			:
																			<div key={vet.id} className="vet-search__card">
																				<div className="vet-search__card-avatar">
																					<img src={getImagePath(vet.avatar, avatarHeight, avatarWidth)} alt="veterinarian"/>
																				</div>
																				<div className="vet-search__card-descr">
																					<h3>{`Dr. ${vet.firstName} ${vet.lastName}`}</h3>
																					<span>{vet.areaName}</span>
																					<span className="vet-search__card-phone">Phone:
																	<a href={`tel:${vet.phoneNumber}`}>{vet.phoneNumber}</a>
																</span>
																				</div>
																				{
																					vet.areaUrl ?
																						<NavLink to={`/find-a-vet/${vet.area.state.split( ' ').join('-')}/${vet.areaUrl}/veterinarians?veterinarian=${vet.id}`}>
																							<button className="btn btn-primary btn-sm">
																								View
																							</button>
																						</NavLink>
																					:
																						null
																				}

																			</div>
																		}
																	</React.Fragment>
																);
															})
														}
													</div>

													<div className="call-us">
														<p className="call-us__text">Can't find who you're looking for?</p>
														{
															isMobile ? <a className="btn btn-md btn-primary" href="tel:855-933-5683">Give us a call</a> :
																<GetInTouchButton btnText={'Give us a call'} />
														}
													</div>
												</div>
												: <VetNotFound isMobile={isMobile}/>
										}
									</>)
									:
									(
										<div className="areas-list-page__not-found">
											<MiddleText
												title={'Want to search by a veterinarian\'s name instead?'}
												text={'Please enter a first and/or last name to find a Lap of Love doctor.'}
											/>
										</div>
									)
							}
						</TabPane> */}
					</Tabs>
				</div>
			</div>
		</div>
	);
};

export default AreasList;